import React from 'react'
import { useTranslation } from 'react-i18next'

interface IProps {
    className?: string
}

const METRICS = [
    ['dashboard.metric.total', '128', 'text-[#205FD8]'],
    ['dashboard.preview.emergency', '2', 'text-[#C92C35]'],
    ['dashboard.preview.fall', '1', 'text-[#D46B13]'],
    ['dashboard.metric.bio', '4', 'text-[#B96B00]']
]

const CarearlyDashboardPreview: React.FC<IProps> = ({ className }) => {
    const { t } = useTranslation()

    return (
        <div className={`${className || ''} aspect-[16/10] min-h-[300px] overflow-hidden rounded-[14px] border border-[#DCE3EC] bg-[#EEF3F8] text-left`}>
            <div className="flex h-[9%] items-center border-b border-[#E0E6EE] bg-white px-[3%]">
                <span className="text-[clamp(9px,1vw,14px)] font-black tracking-[-0.04em] text-[#5960A8]">Carearly</span>
                <span className="ml-[3%] h-[35%] w-px bg-[#DDE3EB]" />
                <span className="ml-[2%] text-[clamp(7px,0.65vw,10px)] font-bold text-[#52627A]">{t('dashboard.preview.title')}</span>
                <span className="ml-auto h-[45%] w-[8%] rounded-full bg-[#EDF2F7]" />
            </div>
            <div className="flex h-[91%]">
                <aside className="w-[15%] bg-[#182B46] p-[2%] text-white">
                    <span className="mb-[18%] block h-[7%] w-[70%] rounded-full bg-white/20" />
                    {[0, 1, 2, 3].map(item => (
                        <span key={item} className={`mb-[10%] block h-[7%] w-full rounded-[5px] ${item === 0 ? 'bg-[#5E6CD9]' : 'bg-white/[0.08]'}`} />
                    ))}
                </aside>
                <div className="relative flex-1 overflow-hidden bg-[linear-gradient(38deg,transparent_47%,rgba(173,190,208,.32)_48%,rgba(173,190,208,.32)_51%,transparent_52%),linear-gradient(-28deg,transparent_45%,rgba(180,197,214,.27)_46%,rgba(180,197,214,.27)_49%,transparent_50%),#EAF0F5] p-[2%]">
                    <div className="absolute inset-0 opacity-60 [background-image:linear-gradient(rgba(166,186,205,.18)_1px,transparent_1px),linear-gradient(90deg,rgba(166,186,205,.18)_1px,transparent_1px)] [background-size:30px_30px]" />
                    <div className="relative z-[1] grid w-[72%] grid-cols-4 gap-[1.5%]">
                        {METRICS.map(([labelKey, value, tone]) => (
                            <div key={labelKey} className="rounded-[8px] border border-white bg-white/95 p-[8%] shadow-sm">
                                <span className="block text-[clamp(5px,0.5vw,8px)] font-semibold text-[#7A8798]">{t(labelKey)}</span>
                                <strong className={`mt-[4%] block text-[clamp(10px,1.2vw,19px)] ${tone}`}>{value}</strong>
                            </div>
                        ))}
                    </div>
                    {[
                        ['26%', '48%', 'bg-[#2F70FF]'],
                        ['48%', '66%', 'bg-[#2F70FF]'],
                        ['61%', '35%', 'bg-[#C92C35]']
                    ].map(([left, top, tone], index) => (
                        <span
                            key={index}
                            className={`absolute z-[1] flex h-[clamp(14px,2.2vw,32px)] w-[clamp(14px,2.2vw,32px)] items-center justify-center rounded-full border-[3px] border-white text-[clamp(6px,0.7vw,10px)] font-bold text-white shadow-md ${tone}`}
                            style={{ left, top }}
                        >
                            {index + 1}
                        </span>
                    ))}
                    <aside className="absolute bottom-[3%] right-[2%] top-[2%] z-[1] flex w-[25%] flex-col rounded-[9px] bg-white p-[2%] shadow-lg">
                        <div className="flex items-center">
                            <strong className="text-[clamp(6px,0.65vw,10px)] text-[#2A3B52]">{t('dashboard.bioAlert.title')}</strong>
                            <span className="ml-auto rounded-full bg-[#FFF0F1] px-[5%] py-[2%] text-[clamp(5px,0.5vw,8px)] font-bold text-[#C92C35]">{t('dashboard.bioAlert.needsCheck')}</span>
                        </div>
                        {[0, 1, 2].map(item => (
                            <div key={item} className="mt-[6%] rounded-[7px] border border-[#F1D3D5] bg-[#FFF9F9] p-[6%]">
                                <div className="h-[5px] w-[42%] rounded-full bg-[#35465D]" />
                                <div className="mt-[6%] h-[4px] w-[72%] rounded-full bg-[#D5DBE3]" />
                                <div className="mt-[10%] flex gap-[4%]">
                                    <span className="h-[12px] flex-1 rounded-[4px] bg-white" />
                                    <span className="h-[12px] flex-1 rounded-[4px] bg-[#243750]" />
                                </div>
                            </div>
                        ))}
                    </aside>
                </div>
            </div>
        </div>
    )
}

export default CarearlyDashboardPreview
